var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsOptional, IsUUID, ValidateNested, } from 'class-validator';
import { TrainingSessionWarningsForTherapistDto } from '../../training-sessions/index.js';
export class ExerciseProgramForPatientListDto {
    id;
    index;
    trainingSessionWarnings;
    startDate;
    endDate;
    static fromExerciseProgram(exerciseProgram) {
        const dto = new ExerciseProgramForPatientListDto();
        dto.id = exerciseProgram.id;
        dto.index = exerciseProgram.index;
        // Persisted programs always carry a start date; a null is only a transient
        // editor state that never reaches persistence.
        dto.startDate = exerciseProgram.startDate ?? new Date();
        dto.endDate = exerciseProgram.endDate;
        dto.trainingSessionWarnings = [];
        return dto;
    }
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramForPatientListDto.prototype, "id", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramForPatientListDto.prototype, "index", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => TrainingSessionWarningsForTherapistDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], ExerciseProgramForPatientListDto.prototype, "trainingSessionWarnings", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ExerciseProgramForPatientListDto.prototype, "startDate", void 0);
__decorate([
    IsDateString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], ExerciseProgramForPatientListDto.prototype, "endDate", void 0);
//# sourceMappingURL=exercise-program-for-patient-list.dto.js.map